import React from 'react';
import ReactDOM from 'react-dom/client';

import App from './App';

// In standalone dev mode, always seed countryCode from VITE_COUNTRIES so
// slices that read sessionStorage on init pick up the correct market.
// Must overwrite unconditionally — a stale value from a previous market
// (e.g. TR → MX switch) would otherwise persist and cause wrong languages.
if (import.meta.env.DEV) {
  const market = import.meta.env.VITE_COUNTRIES;
  if (market) {
    sessionStorage.setItem('countryCode', market);
  }
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
